<script lang="ts">var _a, _b, _c, _d, _e, _f, _g;
import { YinzCamCardsServiceElement } from "yinzcam-cards";
import CardBase from "../../../common/CardBase.svelte";
import { CardsDataSourceRegistration } from "../../../common/CardsDataSourceRegistration";
import { Readable } from "svelte/store";
import { getFirstSourceStore, getTemplatedElementDataFromSource, } from "../../../utilities";
import YCLink from '../../../utilities/YCLink.svelte';
import { ResolvedUrl, resolveUrl } from '../../../../../js/url';
export let element;
export let sources;
export let sourceStore;
$: {
    sourceStore = getFirstSourceStore($sources);
}
;
$: data = (sourceStore && $sourceStore) ? $sourceStore : null;
$: extraData = (data === null || data === void 0 ? void 0 : data.ExtraData) ? JSON.parse(data.ExtraData) : {};
$: currencyImage = String(((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.currencyImage) || "");
$: fontFace = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.fontFace) || "";
$: currencyColor = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.currencyTextColor) || "";
$: currencyFontSize = ((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.currencyFontSize) || 14;
$: fontSize = ((_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.textFontSize) || 16;
$: textColor = ((_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.textColor) || '#fff';
$: text = (data === null || data === void 0 ? void 0 : data.Name) || "";
$: currency_amount = (data === null || data === void 0 ? void 0 : data.PointValue) || 0;
$: image = (extraData === null || extraData === void 0 ? void 0 : extraData.ImageUrl) || "";
$: rewardDetailPage = ((_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.rewardDetailPage) || "FindFilbertRewardDetail";
$: clickthroughUrl = resolveUrl(`${rewardDetailPage}?rewardId=${data === null || data === void 0 ? void 0 : data.RewardID}`);
$: console.log("img: ", image);
</script>

<CardBase {element}>
  <YCLink resolved={clickthroughUrl}>
  <div class="reward-item-wrapper">
    <img class="bg-img" src={image} />
    <div class="text-layout">
      <div class="currency-layout">
        <img src={currencyImage} alt="currency-img" class="currency-img" />
        <span class="" style={`font-size: ${currencyFontSize}; color: ${currencyColor}; font-family: ${fontFace}`}>{currency_amount}</span>
      </div>
      <span class="" style={`font-size: ${fontSize}; color: ${textColor}; font-family: ${fontFace};`}>{text}</span>
    </div>
  </div>
</YCLink>
</CardBase>

<style type="text/scss">*,
*:before,
*:after {
  box-sizing: border-box;
}

.reward-item-wrapper {
  display: flex;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  width: 100%;
}

.bg-img {
  width: 100%;
  height: auto;
}

.text-layout {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: auto;
  padding: 8px;
  z-index: 1;
  position: absolute;
  bottom: 0;
  background: linear-gradient(180deg, rgba(25, 29, 57, 0) 10%, #191D39 90.36%);
  width: 100%;
}

.currency-layout {
  margin-top: auto;
  display: flex;
  gap: 8px;
  align-items: center;
}

.currency-img {
  width: 32px;
  height: 32px;
}</style>
